<template>
  <div class="card mt-2">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <div class="font-weight-bold">
          {{ card.card_number}}
        </div>
        <div>
          <button
            type="button"
            class="btn btn-delete-card m-1"
            @click.stop="confirmDeleteCard(card.id)"
          >
            <i class="las la-trash"></i>
          </button>
        </div>
      </div>

      <div class="mt-1">
        <span class="font-weight-bold">Expiry Date: </span>
        <span>{{ card.expiration_date }}</span>
      </div>
      <div class="mt-1">
        <div class="font-weight-bold">Card holder Name: </div>
        <div>{{ card.card_holder_name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiMixin from '@core/mixin/ApiMixin'

export default {
  name: "Card",
  props: ['card'],
  mixins: [ApiMixin],
  methods: {
    deleteCard(id) {
      this.delete('/customer_cards/' + id, this.formData).then(() => {
        this.$emit('deleted');
      });
    },
    confirmDeleteCard(id) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this card?', {
        title: 'Delete Card',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        centered: true,
        hideHeaderClose: false,
        hideHeader: false,
        bodyClass: 'p-2',
        headerClass: 'p-2'
      })
        .then(value => {
          if (value) {
            this.deleteCard(id);
          }
        })
        .catch(() => {
          // Modal closed without confirming
        });

    }
  }
}
</script>

<style scoped>
  .btn-delete-card {
    background-color: #FF5656;
    color: #fff;
    padding: 0 8px;
    min-height: 32px;
    min-width: 32px;
    border: 1px solid;
    border-radius: 8px;
    border-color: #ebebeb;
  }
</style>
